<template>
  <input
    ref="captchaInput"
    name="v3_captcha_token"
    type="hidden"
  >
</template>

<script>
import recaptchaHelper from '@d-shared/helpers/recaptcha-helper/recaptcha-helper';

export default {
  props: {
    actionName: {
      type: String,
      default: null,
    },
    formId: {
      type: String,
      required: true,
    },
    recaptchaV3Key: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    formEl: null,
  }),
  beforeDestroy() {
    this.formEl.removeEventListener('submit', this.submit);
    this.removeRecaptchaListeners();
  },
  mounted() {
    this.setupForm();
    this.addRecaptchaListeners();
  },
  methods: {
    setupForm() {
      const formEl = document.getElementById(this.formId);
      this.formEl = formEl;
      this.formEl.addEventListener('submit', this.submit);
    },

    setupRecaptcha() {
      recaptchaHelper.setup(this.recaptchaV3Key);
      this.removeRecaptchaListeners();
    },

    addRecaptchaListeners() {
      window.addEventListener('mousedown', this.setupRecaptcha);
      window.addEventListener('mousemove', this.setupRecaptcha);
      window.addEventListener('touchstart', this.setupRecaptcha);
      window.addEventListener('keydown', this.setupRecaptcha);
      window.addEventListener('scroll', this.setupRecaptcha);
    },

    removeRecaptchaListeners() {
      window.removeEventListener('mousedown', this.setupRecaptcha);
      window.removeEventListener('mousemove', this.setupRecaptcha);
      window.removeEventListener('touchstart', this.setupRecaptcha);
      window.removeEventListener('keydown', this.setupRecaptcha);
      window.removeEventListener('scroll', this.setupRecaptcha);
    },

    async submit(ev) {
      ev.preventDefault();

      const recaptchaV3Token = await recaptchaHelper.getTokenV3(this.recaptchaV3Key, this.actionName);
      if (!recaptchaV3Token) {
        this.$errorHandler.log('FormRecaptcha submit: could not get V3 token.');
      }

      this.$refs.captchaInput.value = recaptchaV3Token;
      this.formEl.submit();
    },
  },
};
</script>
